<template>
	<div
		class="modal checkout-expired-modal"
		:class="{ 'checkout-expired-modal--dark': darkTheme }"
		@click="close"
	>
		<div class="modal-holder" @click.stop>
			<span class="close-icon" />
			<span class="modal-title">
				Your order has expired. <br />
				Please re-add products and try again.
			</span>
			<div class="modal-buttons">
				<span class="button single-button" @click="goToMenu">
					Back to Menu
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import storage from '@/utils/storage'
import routerMixin from '@/mixins/routerMixin'

export default {
	name: 'ExpiredCheckoutModal',

	mixins: [routerMixin],

	props: {
		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		...mapState('cart', { cartId: 'id' })
	},

	methods: {
		...mapActions('cart', ['setReceiptShown']),

		async goToMenu() {
			await this.setReceiptShown(this.cartId)
			storage.removeFromStorage('cartId')
			await this.goToProducts()
			this.close()
		},

		close() {
			this.$emit('close')
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.checkout-expired-modal {
	.title {
		padding: 20px 0;
		color: #816cc2;
		font-size: 20px;
	}

	&--dark {
		.modal-holder {
			background-color: $dark-blue;

			.modal-title,
			.modal-content {
				color: $white;
			}
		}
	}
}
</style>
